<label nz-checkbox
       class="label-checkbox"
       [ngModel]="isChecked"
       (ngModelChange)="valueChange($event)"
       [nzDisabled]="isDisabled"
       [ngClass]="labelCss">
       {{label}}
</label>
